import { useState } from 'react';

const followTopics = ['最新爆料', '近况动态', '造型变化', '考古合集', '争议时间线'];

export default function SubscribeCta() {
  const [picked, setPicked] = useState<string[]>(['最新爆料']);
  const [joined, setJoined] = useState(false);

  const toggle = (topic: string) => {
    setPicked((prev) =>
      prev.includes(topic) ? prev.filter((item) => item !== topic) : [...prev, topic],
    );
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="relative overflow-hidden rounded-lg border border-primary-900 bg-primary-950 px-6 py-10 md:px-12 md:py-14">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20texture%20of%20deep%20espresso%20brown%20with%20drifting%20coral%20and%20gold%20light%20particles%2C%20soft%20cinematic%20glow%2C%20minimal%20elegant%20dark%20gradient%20background%2C%20no%20text&width=1600&height=700&seq=fengjian-cta-2026&orientation=landscape"
              alt="追更订阅区背景纹理"
              title="风间由美追更订阅"
              className="h-full w-full object-cover object-top opacity-60"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/85 to-secondary-950/70" />
          </div>

          <div className="relative z-10 flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-primary-950/40 px-3 py-1 text-xs text-accent-300">
                <i className="ri-notification-3-line" aria-hidden="true" />
                追更提醒
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                选定方向，新料一出先看到
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-200">
                挑几个你最关心的话题，之后这个首页会优先把这些方向的爆料排到前面，不用再一条条翻。
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {followTopics.map((topic) => {
                  const on = picked.includes(topic);
                  return (
                    <button
                      key={topic}
                      type="button"
                      onClick={() => toggle(topic)}
                      className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-xs transition-colors ${
                        on
                          ? 'border-accent-400 bg-accent-500 font-medium text-primary-950'
                          : 'border-background-50/30 bg-background-50/10 text-background-100 hover:border-accent-400'
                      }`}
                    >
                      {on ? '✓ ' : '+ '}
                      {topic}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="shrink-0 rounded-lg border border-background-50/20 bg-background-50/5 p-5 backdrop-blur-sm lg:w-72">
              <p className="text-xs text-background-300">已选方向</p>
              <p className="mt-1 font-heading text-2xl font-bold text-background-50">
                {picked.length}
                <span className="ml-1 text-sm font-normal text-background-300">个</span>
              </p>
              <button
                type="button"
                onClick={() => setJoined(true)}
                disabled={picked.length === 0}
                className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-50"
              >
                <i className={joined ? 'ri-checkbox-circle-fill' : 'ri-add-circle-line'} aria-hidden="true" />
                {joined ? '已加入追更' : '加入追更'}
              </button>
              <p className="mt-3 text-center text-[11px] text-background-300">
                {joined ? '方向已记录，随时可回来调整。' : '仅记录你的偏好，不发送任何通知。'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}